(function () {
  'use strict';

  // Network-level interception (not click/submit) — the UpCart app bundle
  // intercepts add-to-cart clicks itself and calls /cart/add.js directly,
  // bypassing the native <product-form> submit event entirely. Patching
  // fetch is the one choke point every add-to-cart path (native Dawn AJAX,
  // UpCart, quick-add) actually goes through.

  var originalFetch = window.fetch;
  if (typeof originalFetch !== 'function') return;

  function collectPreorderIds() {
    var ids = [];
    document.querySelectorAll('[data-preorder-variant-ids]').forEach(function (el) {
      (el.getAttribute('data-preorder-variant-ids') || '').split(',').forEach(function (id) {
        if (id) ids.push(id);
      });
    });
    return ids;
  }

  function extractVariantIds(body) {
    // Dawn's own product-form submits FormData (a single `id` field);
    // UpCart and other direct-fetch callers send a JSON string instead.
    // Both paths need to be recognized here, or switching between them
    // (e.g. removing UpCart) silently disables the acknowledgment gate.
    if (body instanceof FormData) {
      var id = body.get('id');
      return id != null ? [String(id)] : [];
    }

    if (!body || typeof body !== 'string') return [];
    var data;
    try {
      data = JSON.parse(body);
    } catch (e) {
      return [];
    }
    var ids = [];
    if (data && Array.isArray(data.items)) {
      data.items.forEach(function (item) {
        if (item && item.id != null) ids.push(String(item.id));
      });
    } else if (data && data.id != null) {
      ids.push(String(data.id));
    }
    return ids;
  }

  function isCartAddUrl(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(url || '');
  }

  var modal, checkbox, continueBtn, cancelled;

  function ensureModalRefs() {
    if (modal) return true;
    modal = document.getElementById('PreorderAckModal');
    checkbox = document.getElementById('PreorderAckCheckbox');
    continueBtn = document.getElementById('PreorderAckContinue');
    return !!(modal && checkbox && continueBtn);
  }

  function askForAcknowledgment() {
    return new Promise(function (resolve, reject) {
      if (!ensureModalRefs()) {
        resolve();
        return;
      }
      checkbox.checked = false;
      continueBtn.disabled = true;
      cancelled = true;

      // Some cart apps (e.g. an optimistic-open cart drawer) render their
      // own overlay at the max possible z-index and append it to <body>
      // right as add-to-cart is clicked — before this promise's fetch even
      // resolves — which can bury this modal. Match that ceiling and make
      // sure we're the very last element in <body> so DOM order (the
      // tiebreaker at equal z-index) favors us regardless of what else is
      // competing or what it's called.
      document.body.appendChild(modal);
      modal.style.zIndex = '2147483647';

      function onChange() {
        continueBtn.disabled = !checkbox.checked;
      }
      function onContinue() {
        cancelled = false;
        cleanup();
        modal.hide();
        resolve();
      }
      function onModalClosed() {
        cleanup();
        if (cancelled) reject(new Error('Pre-order acknowledgment cancelled'));
      }
      function cleanup() {
        checkbox.removeEventListener('change', onChange);
        continueBtn.removeEventListener('click', onContinue);
        document.body.removeEventListener('modalClosed', onModalClosed);
      }

      checkbox.addEventListener('change', onChange);
      continueBtn.addEventListener('click', onContinue);
      document.body.addEventListener('modalClosed', onModalClosed);
      modal.show(continueBtn);
    });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!isCartAddUrl(url)) {
      return originalFetch.apply(window, arguments);
    }

    var body = init && init.body;
    var variantIds = extractVariantIds(body);
    var preorderIds = collectPreorderIds();
    var isPreorder = variantIds.some(function (id) {
      return preorderIds.indexOf(id) !== -1;
    });

    if (!isPreorder) {
      return originalFetch.apply(window, arguments);
    }

    var args = arguments;
    return askForAcknowledgment().then(function () {
      return originalFetch.apply(window, args);
    });
  };
})();
